'use strict';

import ApiEndpoint from './api_endpoint';

export default class CreatePerson extends ApiEndpoint {
  execute(callback = undefined, session = undefined, params = undefined) {
    if (session === undefined) {
      return this.session.post('/people', params, callback);
    }
    return session.post('/people', params, callback);
  }
}
